// extracted by mini-css-extract-plugin
export var quantityInput = "_my-0";